import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import UserSettingsService from "src/services/userSettingsService";
import { useDispatch, useSelector } from "src/store";
import { makeStyles } from "tss-react/mui";

import { updateSearchQuery } from "@dashboard/devices/store";
import { selectGroups } from "@dashboard/groups/store/selectors";
import { expandGroupIdsWithDescendants } from "@dashboard/groups/utils";
import { Theme, Tooltip, Typography } from "@mui/material";
import ElasticService from "@services/elasticService";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

const useStyles = makeStyles()((theme: Theme) => ({
    link: { color: theme.palette.emteria.link, cursor: "pointer", padding: 0, display: "inline-block" },
    border: { borderBottom: `1px solid ${theme.palette.emteria.border.secondary}` },
}));

const ensureSystemVersionColumnVisible = () => {
    const currentVisibleColumns = UserSettingsService.getDevicePageVisibleColumns();

    const updatedVisibleColumns = {
        ...currentVisibleColumns,
        systemVersion: true,
    };
    UserSettingsService.setWorkspaceValue("devicePage.visibleColumns", updatedVisibleColumns);
};

interface TableItemProps {
    count: number;
    version: string;
    selectedGroupIds: number[];
}

const TableItem = ({ count, version, selectedGroupIds }: TableItemProps) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common"]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const allGroups = useSelector(selectGroups);

    const handleOnClick = (selectedVersion: string) => {
        const filters = [
            { id: "systemVersion", value: [selectedVersion] },
            { id: "licenseStatus", value: ["Used"] },
        ];

        if (selectedGroupIds.length !== 0 && selectedGroupIds.length !== allGroups.length) {
            const expandedGroupIds = expandGroupIdsWithDescendants(selectedGroupIds, allGroups);
            filters.push({ id: "groupName", value: expandedGroupIds.map((id) => id.toString()) });
        }

        UserSettingsService.setWorkspaceValue("devicePage.columnFilters", filters);
        ensureSystemVersionColumnVisible();
        dispatch(updateSearchQuery(""));
        void navigate("/dashboard/devices");
        ElasticService.createTransaction("overviewPageLinkClick", {
            tab: "os-versions",
            text: count,
        });
    };

    return (
        <MinimalTableCell className={classes.border} align="right">
            <Tooltip title={t("common:tooltip.showDevices", { count })}>
                <Typography className={classes.link} onClick={() => handleOnClick(version)}>
                    {count}
                </Typography>
            </Tooltip>
        </MinimalTableCell>
    );
};

export default TableItem;
